import classNames from 'classnames';

import type {
  WidthConstraintResponsive,
  WidthConstraintSize,
} from '../../styles';
import { getConstraintsStyles } from '../../styles';
import type { BoxProps } from '../Box';
import { Box } from '../Box';

export interface ContainerProps extends Omit<BoxProps, 'mx' | 'ml' | 'mr'> {
  /** The maximum width constraints to apply to the container. */
  size?: WidthConstraintSize | WidthConstraintResponsive;
}

/** Create a centered container with a maximum width constraint. */
export function Container(props: ContainerProps) {
  const { size, className, ...boxProps } = props;
  const constraintsClassNames = getConstraintsStyles({
    widthConstraint: size,
  });
  const cssClasses = classNames(constraintsClassNames, className);

  return <Box className={cssClasses} {...boxProps} />;
}
